import { render, staticRenderFns } from "./TyresProd.vue?vue&type=template&id=9194abd8&"
import script from "./TyresProd.vue?vue&type=script&lang=js&"
export * from "./TyresProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports